import React from "react";
import jssaten from "../logo/jssaten-logo.png";
import jssaher from "../logo/jssaher-logo.jpg";
import { Link, NavLink } from "react-router-dom";

export default function Header() {
  return (
    <div id="navbar">
      <div className="flex-between">
        <div className="flex-center">
          <div className="flex-center">
            <Link to="/">
              <img
                src={jssaher}
                alt="JSS logo"
                width="160px"
                height="80px"
                className="img"
              />
            </Link>
          </div>
          <div>
            <ul className="flex-center" id="navbox">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/drugs">Add Drug</NavLink>
              </li>
              <li>
                <NavLink to="/result">Drugs</NavLink>
              </li>
            </ul>
          </div>
        </div>
        <Link to="/">
          <img
            src={jssaten}
            alt="JSS logo"
            width="80px"
            height="80px"
            className="img"
          />
        </Link>
      </div>
    </div>
  );
}
